interface DropdownMenuProps {
    children: React.ReactNode[];
}
export function DropdownMenu({ children }: DropdownMenuProps) {

    return (
        <>
            <div className='large-screen'>{ children }</div> 
            <div className='small-screen dropdown-container'>
                <input type="checkbox" className='dropdown-button' id="dropdown-state" name="dropdown" hidden/>
                <label htmlFor='dropdown-state' className='dropdown-label'>
                    <div className='dropdown-button'>
                        <p>Menu &darr;</p>
                    </div>
                </label>
                <ul className='dropdown-content'>
                    {children.map((option,index) => (<li key={index}>{option}</li>))}
                </ul>
            </div>
        </>
    )
}